<template>
  <div class="modal fade" id="basketModal" tabindex="-1" aria-labelledby="..." style="height: 100% !important;z-index:10002;border-radius:0px !important">
    <div class="modal-dialog modal-fullscreen">
      <div class="modal-content">
        <div class="modal-body scroll-example p-0">
          <button type="button" class="d-none" data-bs-dismiss="modal" aria-label="Close" id="basketForcMapModalCloseBTN"></button>
        <!-- اگر سبد خرید خالی باشد -->
          <div class="h-100 my-auto" v-if="!storeBasket.basketFlag" style="text-align:center;font-weight: 600;">
            <div class="d-flex align-center justify-center flex-column h-100">
              <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 40 588.000000 378.000000"
                preserveAspectRatio="xMidYMid meet" class="">
                <g transform="translate(0.000000,378.000000) scale(0.100000,-0.100000)" stroke="none">
                  <path class="sleepy-z"
                    d="M2740 3150 c0 -18 7 -20 70 -20 40 0 70 -4 70 -10 0 -5 -34 -55 -75 -111 -41 -55 -75 -107 -75 -115 0 -11 22 -14 115 -14 96 0 115 3 115 15 0 18 2 17 -83 20 -37 1 -70 5 -74 8 -3 4 29 52 71 107 42 56 76 110 76 121 0 18 -8 19 -105 19 -98 0 -105 -1 -105 -20z">
                  </path>
                  <path class="sleepy-z"
                    d="M3310 2575 c0 -12 13 -15 55 -15 30 0 55 -2 55 -5 0 -3 -27 -42 -60 -87 -33 -44 -60 -84 -60 -89 0 -5 41 -9 90 -9 73 0 90 3 90 15 0 12 -14 15 -65 15 l-66 0 61 79 c33 44 60 87 60 95 0 13 -14 16 -80 16 -64 0 -80 -3 -80 -15z">
                  </path>
                  <path class="sleepy-z"
                    d="M2640 2286 c0 -10 14 -16 45 -18 l46 -3 -46 -63 c-59 -81 -55 -94 27 -90 78 4 95 28 19 28 -28 0 -51 3 -51 6 0 3 20 32 45 64 62 81 60 90 -20 90 -50 0 -65 -3 -65 -14z">
                  </path>
                  <path class="sleepy-z"
                    d="M3065 1770 c3 -5 17 -10 31 -10 31 0 30 -4 -4 -49 -49 -62 -49 -61 14 -61 59 0 66 15 11 22 l-29 3 29 40 c49 67 49 65 -7 65 -32 0 -49 -4 -45 -10z">
                  </path>
                  <path class="empty-box"
                    d="M1273 1963 c-38 -15 -7 -54 232 -293 l245 -245 0 -630 c0 -478 3 -634 12 -643 9 -9 327 -12 1370 -12 1332 0 1357 0 1368 19 6 13 10 233 10 643 l0 624 225 224 c124 124 228 233 231 243 3 10 0 25 -7 33 -10 12 -86 14 -553 12 l-541 -3 -225 -227 -224 -228 -396 0 -396 0 -244 245 -244 245 -426 -1 c-234 0 -431 -3 -437 -6z m1080 -301 l237 -238 -3 -604 -2 -605 -382 -3 -383 -2 0 600 0 600 254 0 c271 0 292 4 262 46 -13 18 -32 19 -278 22 l-263 3 -202 202 c-112 111 -203 205 -203 209 0 5 163 8 363 8 l363 0 237 -238z m2487 201 c0 -4 -84 -92 -187 -195 l-187 -188 -476 0 -475 0 195 195 195 195 467 0 c258 0 468 -3 468 -7z m-402 -1055 l2 -598 -895 0 -895 0 0 593 c0 327 3 597 7 600 3 4 405 6 892 5 l886 -3 3 -597z">
                  </path>
                  <path class="empty-box"
                    d="M3224 1086 c-14 -35 57 -96 111 -96 28 0 101 45 110 69 11 27 -13 36 -37 14 -58 -53 -89 -54 -135 -8 -40 40 -42 40 -49 21z">
                  </path>
                  <path class="empty-box"
                    d="M3738 1065 c-46 -43 -67 -44 -111 -5 -40 35 -57 38 -57 10 0 -25 74 -80 107 -80 51 0 129 62 117 93 -9 23 -14 22 -56 -18z">
                  </path>
                  <path class="empty-box"
                    d="M3410 706 c-57 -16 -122 -50 -140 -71 -27 -33 9 -34 71 -3 118 58 224 58 352 0 55 -25 68 -28 77 -17 9 11 5 18 -22 35 -97 59 -243 84 -338 56z">
                  </path>
                  <path class="empty-box"
                    d="M154 196 c-3 -8 -4 -23 -2 -33 3 -17 20 -18 224 -21 184 -2 223 0 233 12 9 11 10 20 1 35 -10 20 -19 21 -231 21 -182 0 -221 -2 -225 -14z">
                  </path>
                  <path class="empty-box"
                    d="M739 194 c-9 -11 -10 -20 -2 -32 9 -15 48 -17 419 -17 l409 0 0 30 0 30 -406 3 c-362 2 -408 0 -420 -14z">
                  </path>
                  <path class="empty-box"
                    d="M4661 196 c-9 -11 -10 -20 -1 -35 11 -21 16 -21 474 -21 499 0 503 0 476 49 -11 21 -16 21 -474 21 -391 0 -465 -2 -475 -14z">
                  </path>
                </g>
              </svg>
              <div class=" text-medium text-gray-normal no-select">سبد خرید شما خالی است</div>
              <div class="text-center"><button class="btn btn-success w-50 mt-3" @click="storeBasket.clearBasket();okFuckRelode()">ادامه خرید</button></div>
            </div>
          </div>
          <!-- اگر سبد خرید محصول داشت -->
          <section v-else>
              <!-- دکمه بستن و پاک کردن سبد حرید -->
            <div class="d-flex justify-content-between align-items-center px-3 py-1">
                <button type="button" class="btn btn-transparent border-0 ps-0" style="font-size: 13px;" data-bs-dismiss="modal" aria-label="Close" id="basketModalCloseBTN" @click="okFuckRelode"><i class="fa fa-close pl-1" style="vertical-align: middle;"></i>بستن</button>
                <div class="d-flex justify-content-end align-items-center w-75" @click="storeBasket.deleteBasket()">
                  <p class="mb-0">حذف سبد</p>
                  <button class="btn btn-outline-danger border-0 pe-0 ps-1"  id="emptyBasketBTN" :class="{ 'invisible': !storeBasket.basketFlag}">
                    <i class="fa fa-trash ml-1 "></i>
                  </button>
                </div>
            </div>
            <!-- تغییر فروشگاه -->
            <div class="alert border-0 d-flex justify-content-between align-items-center w-100 rounded-0 mb-0" style="background-color: azure;">  
              <div class="text-start w-50" @click="goShop">
                <i class="fa fa-chevron-right" style="vertical-align: middle;"></i> فروشگاه {{ storeBasket.supplierDetail.name }}
                <div class="badge badge-primary" v-if="storeBasket.supplierDetail.secret != 0" >ارسال محرمانه</div>
              </div>
              <div class="position-relative" v-if="storeBasket.basketArray && storeBasket.basketArray.length > 1">
                <button class="btn bn-light p-1 px-2 border border-1  " style="font-size:12px;font-weight:700;background-color: white;" @click="ifListShop = !ifListShop,storeBasket.isCustomShown = false">تغییر فروشگاه</button>
                <Transition name="slide-fade">
                    <ul class="form-control border-0" style="width:115px;max-width:115px;min-width:115px;font-size: 12px;list-style: none;position:absolute;top:25px;left:0px;background-color:white;border: 1px solid #dfd4d4 !important;padding-bottom: 2px;padding-top: 2px;" v-if="ifListShop">
                        <li class="pr-0 py-1 " style="overflow:hidden;text-overflow: ellipsis;" :class="{'border-bottom' : index < storeBasket.supplierList.length - 1}" v-for="(sitem,index) in storeBasket.supplierList" :value="sitem.id" @click="changeActiveSupplier(sitem.id),ifListShop = !ifListShop,ifListProduct = false">{{ sitem.name }}</li>    
                    </ul>
                </Transition>
              </div>
            </div>
            <!-- محصولات -->
            <article class="px-3 mt-1 mb-3">
              <div class="d-flex align-items-center w-100 pb-2" v-for="(bitem,index) in storeBasket.basketObject" :key="bitem.id" :class="{'bg-light' : (index+1)%2 ==0}">
                  <div style="width:15%">
                    <img  :src="'https://radap.ir/' + bitem.img_url.split(',')[0]" width="50" height="50"  style="max-width: 35px;max-height: 40px;"/>
                  </div>
                  <div style="width:85%">
                    <div class="d-flex align-items-center" >
                        <span class="product-name">{{ bitem.name}}</span>
                        <span class="product-description text-muted">&nbsp{{ bitem.description }}</span>
                    </div>
                      <footer class=" d-flex justify-content-between align-items-center">
                        <div class="d-flex flex-wrap">
                          <del class="text-muted" style="margin-left: 5px;font-size: 14px;" v-if="bitem.discount > 0">{{convertToPersian(String(numberFormat(bitem.prime_price))) }}</del>
                          <strong style="margin-left: 5px; border: 1px solid red; border-radius: 5px; padding: 2px; color: red;font-size: 14px;" v-if="bitem.discount > 0"  :class="{ 'peculiar-discount': bitem.discount > 4 }">%{{convertToPersian(String(numberFormat(bitem.discount))) }}</strong>
                          <strong style="margin-left: 5px;font-size: 14px">{{ convertToPersian(String(numberFormat(bitem.price))) }}<small class="pr-1" style="font-size: 12px">تومان</small></strong>
                        </div>
                        <button-template :id="bitem.id" :sid="bitem.store_place_id" :quantity="bitem.quantity" origin="basket" /> 
                      </footer>
                  </div>
              </div>
            </article>
            <!-- محصولات پیشنهادی -->
            <article class="my-2 w-100" style="background-color:#e9eaeb;" v-if="storeBasket.specialProducts.length">
            <h5 class="px-2 py-1" style="font-size: 16px;font-weight: 700;letter-spacing: 1px;"><span class="fade-member-element"><i class="" ><i class="fa fa-circle text-danger pe-1" style="font-size: 12px;"></i></i></span>یادت نره!</h5>
            <div class="d-flex flex-wrap flex-column " style="max-height:135px;overflow-x:auto">
                  <div class="d-flex align-items-center py-1 bg-light mb-1 mr-1 position-relative" style="width: 228px;" v-for="(bitem,index) in storeBasket.specialProducts" :key="bitem.id">
                    <div style="width: 15%;margin-left: 4px;">
                      <img :src="'https://radap.ir/' + bitem.img_url.split(',')[0]" width="50" height="50" style="max-width: 35px; max-height: 40px;">
                    </div>
                    <div style="width: 85%;">
                      <div class="d-flex align-items-center" style="width:160px;">
                        <span class="suggest-product-name">{{ bitem.name }}</span>
                        <span class="suggest-product-description text-muted" v-if="bitem.description">&nbsp{{ bitem.description }}</span>
                      </div>
                      <div class="d-flex ">
                        <div v-if="bitem.discount > 0" class="d-flex align-items-center">
                          <del style="margin-left: 5px; font-size: 14px;">{{ convertToPersian(String(numberFormat(bitem.prime_price))) }}</del>
                          <strong style="margin-left: 5px; font-size: 12px;padding-right: 2px;padding-left: 2px;padding-bottom: 0" class="rounded"  :class="{ 'peculiar-discount': bitem.discount > 4 , 'not-peculiar-discount' : bitem.discount <= 4 }">%{{convertToPersian(String(numberFormat(bitem.discount))) }}</strong>
                        </div>
                        <strong style="margin-left: 5px; font-size: 14px;">{{ convertToPersian(String(numberFormat(bitem.price))) }}<small class="pr-1" style="font-size: 12px;">تومان</small>
                      </strong>
                      </div>
                    </div>
                    <div class="position-absolute" style="left:0;top:2px">
                      <button-template :id="bitem.id" :sid="bitem.store_place_id" :quantity="bitem.quantity" origin="basket" /> 
                    </div>
                  </div>
                
            </div>
            </article>
            <hr class="my-0"/>
            <!-- توضیحات -->
            <div v-if="storeBasket.supplierDetail.secret != 0" class="alert alert-warning my-0 text-center rounded-0" style="font-size: 14px;font-weight: 900;text-shadow: 1px 1px 2px #ffd4d4;box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;">تمام سفارشات از این فروشگاه در بسته بندی کاملا محرمانه و بدون درج محتوی و نام فروشگاه ارسال میشود.</div>
            <article class="px-2 my-2">
              <div class="d-flex" style="flex-direction: column;">
                  <div class="d-flex justify-content-between" style="align-items: center;">
                    <span style="font-size: 14px;font-weight: 700;"> توضیحات : </span>
                        <button class="btn btn-transparent border-0 py-0" style="font-size: 12px;" @click="descriptionFlag = !descriptionFlag" v-if="descriptionFlag">
                          بستن
                          <i class="fa fa-minus" style="vertical-align: middle;"></i>
                        </button>
                      <button class="btn btn-transparent border-0 py-0 transition" style="font-size: 12px;" @click="descriptionFlag = !descriptionFlag" v-else >
                        نوشتن توضیحات
                        <i class="fa fa-plus" style="vertical-align: middle;"></i>
                      </button>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="w-100" v-if="descriptionFlag">
                        <button class="btn btn-light p-1 mx-1" v-for="item in texts" :key="item.id" @click="setText(item.id)" style="font-size: 12px;">{{ item.title }}</button>
                      </div>
                      <div v-if="storeBasket.description.length" @click="storeBasket.description = ''" class="d-flex align-items-center pl-1 text-danger" style="font-size:14px">
                        <i class="fa fa-close pl-1" ></i><small style="width:max-content">پاک کردن</small>
                      </div>
                    </div>
                      <textarea v-if="descriptionFlag" v-model="storeBasket.description" rows="4" style="font-size: 13px;transition: .5s; " class="p-1 mt-2 "  placeholder="چنانچه توضیحی راجع به سفارش دارید اینجا بنویسید"></textarea>
                </div>
            </article>
            <!-- کدتخفیف -->
            <article class="px-2 my-2">
              <div class="input-group my-0" v-if="storeBasket.isDamp">
                  <input type="text" class="radius-right form-control damp-border ps-1" style="font-size: 13px;" placeholder="کد تخفیف تان را اینجا وارد کنید" v-model="storeBasket.dampVal">
                  <span class="radius-left input-group-text btn damp-border font-small-2 text-light bg-primary" role="button" @click="storeBasket.validDamp()">اعمال</span>
              </div>
              <div v-else class="d-flex justify-content-between align-items-center">
                <div class="w-50"  style="font-size: 14px;font-weight: 700;">
                  کد تخفیف دارید؟ 
                </div>
                <button class="btn btn-primary  text-start font-small " style="width:fit-content;padding:0 .6em" @click="storeBasket.isDamp = true">
                <img src="./wallet2.png" width="30" style="height:auto"/>
                اینجا وارد کنید
                </button>
              </div>
            </article>
            <hr class="my-0"/>
            <!-- آدرس -->
            <article class="px-2 my-2"> 
                  <div class="d-flex justify-content-between">
                    <span class="labeler" style="font-size:14px">آدرس تحویل:</span>
                    <button class="bg-transparent border-0 pr-0 add-location" style="font-size:14px" @click="getMapModal">
                      <i class="fa fa-edit ml-1"></i>
                      <span class="form-check-label" >انتخاب آدرس</span>
                    </button>
                  </div>
                  <div v-if="storeBasket.location">
                    <i class="fa fa-map-marker ml-1" style="vertical-align:middle"></i>
                    <span style="font-size:16px;font-weight: 700;" id="basketLocationTemp">{{ storeBasket.location }}</span>
                  </div>
                  <div v-else>
                    <span style="font-size:14px;font-weight: 700;" >لطفا آدرس تحویل را انتخاب کنید</span>
                  </div>
            </article>
            <hr class="my-0"/>
            <!-- فاکتور فروش -->
            <article class="px-2 my-1 mb-2">
                <div class="d-flex justify-content-between align-items-center mt-2 ">
                  <span style="font-size: 16px;font-weight: 700;">جمع صورتحساب : </span>
                  <span style="font-size: 16px;font-weight: 700;">{{ convertToPersian(String(numberFormat(storeBasket.primeAmount))) }}تومان</span>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-1" v-if="storeBasket.useRewardFlag">
                  <span class="" style="font-size: 16px;font-weight: 700;">کد تخفیف :</span>
                  <span style="font-size: 16px;font-weight: 700;" class="">{{convertToPersian(String(numberFormat(parseInt(storeBasket.rewardAmount)))) }} تومان </span>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-2 ">
                  <span class="basket-message text-success" style="font-size: 16px;font-weight: 700;">سود شما از این خرید :</span>
                  <span class="text-success" style="font-size: 16px;font-weight: 700;">{{convertToPersian(String(numberFormat(storeBasket.discount + storeBasket.rewardAmount))) }} تومان </span>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-2 " v-if="storeBasket.regentProfit">
                  <span class="basket-message text-success" style="font-size: 16px;font-weight: 700;">سود دعوت کننده شما :
                    <OffcanvasBenfit />
                  </span>
                  <span class="text-success" style="font-size: 16px;font-weight: 700;">{{convertToPersian(String(numberFormat(storeBasket.regentProfit))) }} تومان</span>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-2 ">
                  <span class="basket-message " style="font-size: 16px;font-weight: 700;">هزینه ارسال :</span>
                  <span style="font-size: 16px;font-weight: 700;" v-if="storeBasket.supplierDetail.deliveryCost > 0">{{ convertToPersian(String(numberFormat(storeBasket.supplierDetail.deliveryCost))) }}تومان </span>
                  <span style="font-size: 16px;font-weight: 700;" class="text-primary" v-else>رایگان!</span>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-2 " v-if="storeBasket.useWalletFlag">
                  <span class="text-primary" style="font-size: 16px;font-weight: 700;">کیف پول : <i class="fa fa-info-circle" style="opacity: .8;vertical-align: middle;" v-if="storeBasket.isCustom" @click="storeBasket.getCustomWallet"></i></span>
                  <span style="font-size: 16px;font-weight: 700;" class="text-primary">{{convertToPersian(String(numberFormat(storeBasket.wallet)))}} تومان </span>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-2">
                  <span style="font-size: 18px;font-weight: 700;"> مبلغ قابل پرداخت : </span>
                  <span>
                    <b style="font-size: 18px;font-weight: 700;" v-if="storeBasket.amount - parseInt(storeBasket.rewardAmount) > 0">{{convertToPersian(String(numberFormat(storeBasket.amount - parseInt(storeBasket.rewardAmount)))) }} تومان</b> 
                    <b style="font-size: 18px;font-weight: 700;" v-else>{{ convertToPersian(String(0)) }} تومان</b>
                  </span>
                </div>
            </article>
            <hr class="my-0"/>
            <!-- روش پرداخت -->
            <article class="px-2 my-2">
              <div  v-if="storeBasket.supplierDetail.minSale <= (parseInt(storeBasket.primeAmount) - parseInt(storeBasket.discount)) && storeBasket.finallFlag">
                  <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button class="btn w-100 bg-light " style="border-bottom-right-radius: 0;border-bottom-left-radius: 0;font-size: 14px;">
                          روش پرداخت
                        </button>
                      </h2>
                      <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          <div class="d-flex justify-content-around btn-group bg-light">
                            <button class="font-small w-50 btn  pay-methode-item pay-onlion" :class="{'btn-success' : !storeBasket.useWalletFlag}" @click="storeBasket.setPaymentMethod(1)">
                              <img src="./correct.png" width="20" style="height:auto;"/>پرداخت آنلاین</button>
                            <button class="font-small w-50 btn pay-methode-item pay-wallet" :class="{'btn-success' : storeBasket.useWalletFlag}" @click="storeBasket.setPaymentMethod(2)">
                              <img src="./wallet1.png" width="20" style="height:auto;margin-left:4px"/>اعتبار کیف پول</button>
                            <!-- <button class="font-small w-50 btn pay-methode-item pay-wallet" @click="alertBox('در حال حاضر این سرویس در دسترس نیست، از شکیبایی شما سپاسگذاریم')">
                              <img src="./wallet1.png" width="20" style="height:auto;margin-left:4px"/>اعتبار کیف پول</button> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </article>
            <!-- نهایی کردن سبد خرید -->
            <div class="px-2 my-2" v-if="storeBasket.supplierDetail.minSale <= (parseInt(storeBasket.primeAmount) - parseInt(storeBasket.discount))">
              <button v-if="storeBasket.finallFlag && storeBasket.paymentAllow" class="btn btn-success w-100 mt-3 visibility-hidden" style="color: white;padding: 10px;" @click="goToGetway">
                نهایی کردن خرید
              </button>
              <button v-else class="btn btn-success w-100 mt-3 visibility-hidden"
                style="color: white;padding: 10px;" disabled>
                <div class="spinner-border text-light" role="status"
                  style="vertical-align: middle;margin-left: 10px;width: 20px;height: 20px;">
                  <span class="visually-hidden">Loading...</span>
                </div>
                لطفا شکیبا باشید
              </button>
            </div>
            <!-- حداقل خرید -->
            <div class="px-2 my-2" v-else >
              <div>
                <div class="d-flex justify-content-between px-1">
                    <span class="d-block  m-0" style="font-size:14px;font-weight:700;letter-spacing: 0;">حداقل خرید : {{ convertToPersian(String(numberFormat(storeBasket.supplierDetail.minSale))) }} تومان</span>
                    <span style="font-size:14px;font-weight:700;letter-spacing: 0;">باقی مانده : {{ convertToPersian(String(numberFormat(parseInt(storeBasket.supplierDetail.minSale) - (parseInt(storeBasket.primeAmount) - parseInt(storeBasket.discount)))))}} تومان</span>
                </div>
                <div class="progress my-1" style="height:10px;border-radius: 10px;padding:1px">
                  <div class="progress-bar" role="progressbar" style="background-color: #f76868;border-radius: 10px" aria-valuemin="0" aria-valuemax="100" :style="{ width: ((parseInt(storeBasket.primeAmount) - parseInt(storeBasket.discount)) * 100) / parseInt(storeBasket.supplierDetail.minSale) + '%' }"></div>
                </div>
              </div>  
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
  <loading-temp v-if="loading"/>
  <unavalible-basket :items="storeBasket.basketUnavalibale"/>
  <locations-temp />
</template>
<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/store/auth'
import { alertBox } from '@/composables/silverBox.js' 
import { convertToPersian,numberFormat } from '@/composables/digits.js';
import { useBasket } from '@/store/basket'
import OffcanvasBenfit from './BenefitTemp.vue';
import UnavalibleBasket from './UnavalibleBasket.vue';
import LoadingTemp from '@/components/section/item/loading.vue';
import ButtonTemplate from './../item/button.vue'
import LocationsTemp from "@/components/section/popup/Locations.vue"

let auth = useAuth()
const router = useRouter();
const storeBasket = useBasket();
storeBasket.getSupplierNames()
storeBasket.getBasket()
// بررسی باز  و بسته بودن فروشگاه 
let checkClose = ref(true);
// چک کردن لاگین کاربر
let profile = ref();
// چک کردن لاگین کاربر 
let proFlag = ref(false);
// زمان تحویل
let dayTime = ref();
let descriptionFlag = ref(false);
// let walletTextFlag = ref(false);
let loading = ref(false)
let ifListShop = ref(false)
let texts = ref([
                  {
                    id : 1,
                    title : 'دستچین',
                    txt : ' لطفا تمامی اقلام سفارش دستچین شود. '
                  },
                  {
                    id : 2,
                    title : 'فاکتور',
                    txt : ' لطفا فاکتور سفارش ارسال شود. '
                  },
                  {
                    id : 3,
                    title : 'بسته بندی جدا',
                    txt : ' لطفا در بسته بندی جدا و مجزا قرار دهید. '
                  },
                  {
                    id : 4,
                    title : 'تماس',
                    txt : ' لطفا با این شماره تماس بگیرید: '
                  }
      ]);
function setText(id){
  let item = texts.value.find(item => item.id == id);
  if(!storeBasket.description.includes(item.txt)){
    storeBasket.description += item.txt
  }
}
// بررسی باز و بسته بودن فروشگاه درون سبد خرید
async function checkClosed() {
  if(localStorage.getItem('basket')){
    if (storeBasket.basketFlag) {
      let response = await fetch("https://radap.ir/Backend/api/section/basket/check_close.php?supplier_id=" + storeBasket.supplierDetail.id)
      let data = await response.text()
          if(data == 0) {
            checkClose.value = true
          } else {
            checkClose.value = false
          }
    }
  }
}
// نهایی کردن خرید 
async function goToGetway() {
  validLogin()
  // اگر کاربر وارد شده بود
  if (proFlag.value) {
    loading.value = true
      // اگر آدرس انتخاب نکرده بود
      if (!storeBasket.location) {
        alertBox('لطفا آدرستان را انتخاب کنید','info',2)
        loading.value = false
        getMapModal()
      } else {
      storeBasket.finallFlag = false
      await checkClosed()
      if(checkClose.value) {
        storeBasket.isCustomShown = true
        storeBasket.getBasket()
          checkClose.value = false
          if(!storeBasket.basketUnavalibale.length){
            getWayURL()
          }
        } else {
          alertBox('فروشگاه در حال حاضر بسته است لطفا لحظاتی بعد تلاش کنید')
          storeBasket.finallFlag = true
        }
      }
  } else {
    // رفتن به پاپ اپ ورود
    goToLogin()
  }
}
// رفتن به درگاه یا کیف پول
function getWayURL() {
  storeBasket.finallFlag = false
  dayTime.value = 'اسرع وقت';
  // اضافه کردن مبلغ کیف پول که قبل کم شده بود
  storeBasket.virsual_amount = storeBasket.amount + Number(storeBasket.wallet)
  if (storeBasket.useWalletFlag && Number(storeBasket.wallet) >= storeBasket.virsual_amount) {
      fetch("https://radap.ir/Backend/api/getway/wallet.php?amount=" + storeBasket.virsual_amount + "&mobile=" + auth.profile.mobile + "&vendor_id=" + storeBasket.supplierDetail.id + "&address=" + storeBasket.location + "&coordinates=" + storeBasket.coordinates + "&dayTime=" + dayTime.value + "&items=" + storeBasket.allItems + "&reward=" + 'a' + storeBasket.rewardAmount + '&description=' + 'a' + storeBasket.description + '&damp=' + 'a' + storeBasket.dampVal)
      .then((res) => res.text())
      .then((data) => {
          window.location.href = data;
          loading.value = false
      })
    .catch((error) => {
      alertBox('مشکلی پیش آمده است... لطفا دوباره امتحان کنید');
    });
  } else {
    fetch("https://radap.ir/Backend/api/getway/request.php?amount=" + storeBasket.amount + "&mobile=" + auth.profile.mobile + "&vendor_id=" + storeBasket.supplierDetail.id + "&address=" + storeBasket.location + "&coordinates=" + storeBasket.coordinates + "&dayTime=" + dayTime.value + "&items=" + storeBasket.allItems + "&reward=" + 'a' + storeBasket.rewardAmount + '&useWallet=' + storeBasket.useWalletFlag + '&description=' + 'a' + storeBasket.description + '&damp=' + 'a' + storeBasket.dampVal)
    .then((res) => res.text())
    .then((data) => {
      window.location.href = data;
      loading.value = false
    })
    .catch((error) => {
      alertBox('مشکلی پیش آمده است... لطفا دوباره امتحان کنید');
    });
  }
}
// پاپاپ انتخاب ادرس
function getMapModal() {
  validLogin()
  // اگر کاربر وارد شده بود
  if (proFlag.value) {
    storeBasket.useWalletFlag = false
    okFuckRelode()
    // document.getElementById('basketModal').setAttribute('inert', '');
    // document.getElementById('mapModal').removeAttribute('inert');
    document.getElementById('mapModalBTN').click()
  }else {
    // رفتن به پاپ اپ ورود
    goToLogin()
  }
}
// چک کردن لاگین کاربر
function validLogin() {
  auth.getToken()
  if (auth.token && auth.profile.id) {
    proFlag.value = true;
    profile.value = auth.profile;
  } else {
    proFlag.value = false;
  }
}
function goToLogin() {
  alertBox('لطفا ابتدا وارد شوید.','error',2)
  document.querySelector('#basketForcMapModalCloseBTN').click();
  document.querySelector('#loginsModalBTN').click();
}
function okFuckRelode() {
  document.getElementById('basketForcMapModalCloseBTN').click()
}
// function 
function goShop() {
  okFuckRelode()
  router.push({ name: 'StoreElement', params: { id: storeBasket.supplierDetail.id } })
}
function changeActiveSupplier(sid){
  storeBasket.setBasketSupplierID(sid)
  storeBasket.getBasket()
  storeBasket.clearDamp()
  storeBasket.expierDamp()
}
</script>
<style scoped>
.not-peculiar-discount{
  border:1px solid red;
}
.justify-center {
  display: flex !important;
  -webkit-box-pack: center !important;
  justify-content: center !important;
}
.ftzowr svg {
  height: 13rem !important;
  max-height: 31vh;
  color: rgb(117, 117, 117);
}

.text-gray-normal {
  color: rgb(117, 117, 117);
}

.font-small {
  font-size: 12px;
}
.font-small-2 {
  font-size: 14px;
}
.damp-border{
  border: 1px solid #817d9d;
}
.radius-right{
  border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
}
.radius-left{
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.suggest-product-name{
  font-size: 13px;
  /* max-width: 125px;
  min-width: 125px; */
  width: min(max-content,140px);
  /* max-width: 140px;
  min-width: max-content; */
  /* min-width: 50%; */
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
}
.suggest-product-description{
    display: inline-block;
    font-size: 11px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: "IranSans";
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.3s ease-out;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
@keyframes fade-member {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.fade-member-element {
  animation: fade-member 1s infinite;
}
.product-description{
    display: inline-block;
    max-width: 100%;
    /* height: 20px; */
    font-size: 10px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: "IranSans";
}
.product-name{
  max-height: 30px;
  font-size: 13px;
  min-width: max-content;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>